import { api } from 'services/api';

const videoCallService = api.injectEndpoints({
  endpoints: (builder) => ({
    checkSocket: builder.mutation<ResultModel<void>, CheckSocketRequest>({
      query: (body) => ({
        url: `/423B66B430FB75028A/CheckPatientAppointmentCallSocket`,
        method: 'POST',
        body,
      }),
    }),
    loginVideoCall: builder.mutation<ResultModel<void>, LoginVideoCallRequest>({
      query: (body) => ({
        url: `/423B66B430FB75028A/LoginVideoCall`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCheckSocketMutation, useLoginVideoCallMutation } = videoCallService;
